<template>
  <div style="background-color: #f5f5f5">
    <HeaderView :title="$t('service.title')" />
    <div class="view-page">
      <div class="service-card">
        <div class="card-header">
          <div class="service-info">
            <img
              
              class="service-avatar"
              src="../../assets/img/mine/kefu.png"
              alt="Customer Service"
            />
            <div class="service-name">
              {{  $store.getters.getBaseInfo.name  }}
            </div>
          </div>
          <button class="contact-btn">
            <a target="_bank" :href="$store.getters.getBaseInfo.kefu" >{{ $t('service.link') }}</a>
          </button>
        </div>
        <div class="card-footer">
          <div class="info-text">
            {{ $t('service.tip') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from "@/components/Header/index.vue";
export default {
  name: "ServiceView",
  components: { HeaderView },
};
</script>
<style lang="scss" scoped>
.service-card {
    margin: 1rem;
    padding: 1.5rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px #00000014
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem
}

.service-info {
    display: flex;
    align-items: center;
    flex: 1
}

.service-avatar {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: 0 2px 8px #0000001a
}

.service-name {
    margin-left: 1rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: #323233
}

.contact-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .6rem 1.5rem;
    background: linear-gradient(135deg,#7d76ef,#d63f8c);
    border: none;
    border-radius: 20px;
    box-shadow: 0 4px 12px #7d76ef4d;
    cursor: pointer;
    transition: all .3s ease
}

.contact-btn:active {
    transform: scale(.95);
    box-shadow: 0 2px 6px #7d76ef4d
}

.contact-btn a {
    color: #fff;
    font-size: .9rem;
    font-weight: 500
}

.card-footer {
    padding: .8rem 1rem;
    background: #f7f8fa;
    border-radius: 8px
}

.info-text {
    text-align: center;
    font-size: .85rem;
    color: #969799;
    line-height: 1.5
}

</style>
